import { render, staticRenderFns } from "./ProfileOnboard.vue?vue&type=template&id=63ad1632&"
import script from "./ProfileOnboard.vue?vue&type=script&lang=js&"
export * from "./ProfileOnboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports